import { render } from "./AdminKycView.vue?vue&type=template&id=6eb5eef8&scoped=true"
import script from "./AdminKycView.vue?vue&type=script&lang=js"
export * from "./AdminKycView.vue?vue&type=script&lang=js"

import "./AdminKycView.vue?vue&type=style&index=0&id=6eb5eef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb5eef8"]])

export default __exports__